module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// ./node_modules/.pnpm/axios@0.24.0/node_modules/axios/index.js
// module id = 137
// module chunks = 0